import { Vehicle, VehicleLocation } from 'server'
import { defaultVehicleFilter } from '../../../utils/filtering'

export const filterDeviceList = (
  vehicles: Vehicle[],
  vehicleLocationMap: Map<number, VehicleLocation>,
  vehicleIds: number[], // in collections
  selectedAgency: number | undefined,
  searchString: string,
  texasMask = false
) => {
  const filtered: Vehicle[] = []

  for (const vehicle of vehicles.values()) {

    const vehicleLocation = vehicleLocationMap.get(vehicle.vehicle_id)

    if (!vehicleLocation) {
      continue
    }

    // Check if in collection
    if (vehicleIds.length && !vehicleIds.includes(vehicle.vehicle_id)) {
      filtered.push(vehicle)
    } else {
      if (selectedAgency) {
        if (vehicle.agency_id !== selectedAgency) {
          continue
        }
      }

      if (searchString) {
        const searchPieces = searchString.split(' ')
        if (
          !searchPieces.some((piece: string) => {
            return (
              vehicle.name.toLowerCase().includes(piece.toLowerCase()) ||
              vehicle.asset_id.toLowerCase().includes(piece.toLowerCase()) ||
              vehicle.vehicle_id.toString().toLowerCase().includes(piece.toLowerCase())
            )
          })
        ) {
          continue
        }
      }
      filtered.push(vehicle)
    }
  }

  return filtered
}
